/* eslint-disable arrow-body-style */
import { Button, Grid2 as Grid, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import CTabPanel, { CTab, CTabs } from 'components/reusable/CTabPanel';
import React, { useMemo, useState } from 'react';
import MainCard from 'ui-component/cards/MainCard';

import AssessmentForm from './AssessmentForm';
import { useParams } from 'react-router-dom';
import { decriptId } from 'utils/encription';
import History from 'components/common/History';
import { useLazyGetPsychologyAssessmentHistoryQuery } from 'store/services/pshychologicalAssessment';
import ViewBilling from 'components/therapy/ViewBillingDetails';
import AssessmentView from './AssessmentView';
import { useAssessmentForm } from './useAssessmentForm';

export const HISTORY_ACTIONS = [
    {
        label: 'Create',
        value: 'create'
    },
    {
        label: 'Update',
        value: 'update'
    },
    {
        label: 'Delete',
        value: 'delete'
    }
];

const AddEdit = () => {
    const [activeTab, setActiveTab] = useState(0);
    const handleChange = (_e, newValue) => setActiveTab(newValue);

    const { id } = useParams();
    const AssessmentId = decriptId(id);
    const { detail } = useAssessmentForm({ AssessmentId });
    const historyData = useLazyGetPsychologyAssessmentHistoryQuery();
    const historyPayload = useMemo(
        () => ({
            filters: {
                psychological_testing_id: AssessmentId
            }
        }),
        [AssessmentId]
    );

    const [printTrigger, setPrintTrigger] = useState(false);

    const handlePrint = () => {
        setPrintTrigger(true);
        setTimeout(() => setPrintTrigger(false), 500);
    };

    return (
        <MainCard
            title={
                <Stack
                    direction="row"
                    sx={{
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                    }}
                >
                    <Typography
                        variant="h3"
                        sx={{
                            mr: 1,
                            color: '#616161',
                            fontWeight: 500,
                            lineHeight: 1
                        }}
                    >
                        {id ? 'Edit Psychological Testing' : 'Add Psychological Testing'}
                    </Typography>

                    {AssessmentId && (
                        <Stack
                            direction="row"
                            spacing={2}
                            sx={{
                                alignItems: 'center',
                                ml: 'auto'
                            }}
                        >
                            <ViewBilling billingId={detail?.fields?.billing_details} isMentalHealth />
                            <Button variant="contained" onClick={handlePrint}>
                                Print
                            </Button>
                        </Stack>
                    )}
                </Stack>
            }
        >
            <Box>
                <CTabs value={activeTab} onChange={handleChange}>
                    <CTab label="Psychological Testing" />
                    {AssessmentId && <CTab label="History" />}
                </CTabs>

                <CTabPanel value={activeTab} index={0}>
                    <AssessmentForm AssessmentId={AssessmentId} />
                </CTabPanel>

                <CTabPanel value={activeTab} index={1}>
                    <History data={historyData} payload={historyPayload} actions={HISTORY_ACTIONS} />
                </CTabPanel>
            </Box>
            {AssessmentId && <AssessmentView onPrintClick={printTrigger} data={detail?.fields} />}
        </MainCard>
    );
};

export default AddEdit;
